import { ChevronRight } from "lucide-react";

interface Crumb {
  label: string;
  onClick?: () => void;
}

interface LeagueBreadcrumbProps {
  crumbs: Crumb[];
}

export function LeagueBreadcrumb({ crumbs }: LeagueBreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0">
      <ol role="list" className="flex items-center min-w-0">
        {crumbs.map((crumb, i) => (
          <li key={i} className="min-w-0">
            <div className="flex items-center min-w-0">
              {i > 0 && (
                <ChevronRight
                  aria-hidden="true"
                  className="size-4 shrink-0 text-muted-foreground"
                />
              )}
              {crumb.onClick ? (
                <button
                  type="button"
                  onClick={crumb.onClick}
                  title={crumb.label}
                  className={`${i === 0 ? "mr-2" : "ml-2"} flex items-center gap-1 text-sm font-medium text-text-muted hover:text-text-primary transition-colors min-w-0 max-w-[12rem] sm:max-w-[18rem]`}
                >
                  <span className="truncate">{crumb.label}</span>
                </button>
              ) : (
                <span
                  aria-current={i === crumbs.length - 1 ? "page" : undefined}
                  title={crumb.label}
                  className={`${i > 0 ? "ml-2" : ""} text-sm font-medium text-muted-foreground min-w-0 truncate max-w-[12rem] sm:max-w-[18rem]`}
                >
                  {crumb.label}
                </span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
